// @flow
import ApplicationModel from "../models/application/ApplicationModel";
import CaseViewModel from "../models/caseview/CaseViewModel";
import TabModel from "../models/tab/TabModel";
import GroupingPanelModel from "../models/panels/GroupingPanelModel";
import DetailModel from "../models/detail/DetailModel";
import UserProfileModel from "../models/user/UserProfileModel";

import { useModularUIBasic } from "./useModularUIBasic";

import type Href from "../models/href/Href";
import type { HookOptions } from "./useModularUIBasic";

/**
 * Load application
 */
export const useApplication = (
  options?: HookOptions,
): ApplicationModel | null =>
  useModularUIBasic("application", "/", {
    expectedModels: ["Application"],
    targetModel: ApplicationModel,
    removeOnUnmount: options?.removeOnUnmount ?? false,
    ...options,
  });

/**
 * Load a tab by href
 */
export const useTab = (
  href: string | Href,
  options?: HookOptions,
): TabModel | null =>
  useModularUIBasic("tab", href, {
    expectedModels: ["Tab"],
    targetModel: TabModel,
    ...options,
  });

/**
 * Load caseview by href
 */
export const useCaseView = (
  href: string | Href,
  options?: HookOptions,
): CaseViewModel | null =>
  useModularUIBasic("caseview", href, {
    expectedModels: ["CaseView"],
    targetModel: CaseViewModel,
    ...options,
  });

/**
 */
export const useGroupingPanel = (
  href: string | Href,
  options?: HookOptions,
): GroupingPanelModel | null =>
  useModularUIBasic("groupingpanel", href, {
    expectedModels: ["GroupingPanel"],
    targetModel: GroupingPanelModel,
    ...options,
  });

/**
 */
export const useDetailPanel = (
  href: string | Href,
  options?: HookOptions,
): DetailModel | null =>
  useModularUIBasic("detailpanel", href, {
    expectedModels: ["Detail"],
    targetModel: DetailModel,
    ...options,
  });

/**
 */
export const useUserProfile = (
  href: string | Href,
  options?: HookOptions,
): UserProfileModel | null =>
  useModularUIBasic("userprofile", href, {
    expectedModels: ["UserProfile"],
    targetModel: UserProfileModel,
    ...options,
  });
